import { BaseService, Service } from "/@/cool";
@Service("orderRepairReference")
class OrderRepairReference extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}
		this.permission["list"] = prefix + "list";
	}

	list(params: any) {
		return this.request({
			url: "/list",
			method: "POST",
			data: {
				...params
			}
		});
	}
}
export default OrderRepairReference;
